import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { KeyRound } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success("If an account exists, a reset link has been sent to your email.");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-72px)] flex items-center justify-center px-4 py-12 bg-[#FDFBF7]">
      <Card className="w-full max-w-md p-8 border-[#EAE3D2] shadow-xl bg-white" data-testid="forgot-password-card">
        <div className="flex items-center gap-3">
          <KeyRound className="w-7 h-7 text-[#6B1D2F]" />
          <h1 className="font-serif text-3xl font-semibold text-slate-900">Forgot password?</h1>
        </div>
        <p className="text-sm text-slate-600 mt-2">
          Enter the email you signed up with. We'll send you a secure link to set a new password. The link expires in 1 hour.
        </p>

        {sent ? (
          <div className="mt-6 p-4 rounded-lg bg-emerald-50 border border-emerald-200 text-sm text-emerald-900" data-testid="forgot-password-sent">
            If an account exists for <b>{email}</b>, a reset link has been sent. Please check your inbox (and spam folder).
          </div>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <Label htmlFor="fp-email" className="text-slate-700">Email address</Label>
              <Input id="fp-email" data-testid="forgot-password-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1" placeholder="you@example.com" />
            </div>
            <Button type="submit" disabled={busy} data-testid="forgot-password-submit" className="w-full bg-[#6B1D2F] hover:bg-[#541624] text-white rounded-full py-6">
              {busy ? "Sending…" : "Send reset link"}
            </Button>
          </form>
        )}

        <p className="text-sm text-center text-slate-600 mt-6">
          Remembered it? <Link to="/login" data-testid="forgot-back-to-login" className="text-[#6B1D2F] font-semibold">Back to sign in</Link>
        </p>
      </Card>
    </div>
  );
}
